import Idea from 'components/framework/models/Idea';
import RecordFields from '../RecordFields';
import { registerRecordFieldsClasses } from './index';

export default class IdeaFields extends RecordFields {
  static modelClass = Idea;
}

registerRecordFieldsClasses({ IdeaFields });
